import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d40eac1c"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["element-loading-background"];
const _hoisted_2 = {
  class: "left-warp"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["element-loading-background"];
import { axiosInstanceAll } from '@/api/instance';
import { getVodPlusIndexApi } from '@/api/vodPlus';
import { vodPlusBaseUrl } from '@/utils';
import { inject, onMounted } from 'vue';
import OtherStyleCardItem from './otherStyleCardItem.vue'; // 运营方案主题数据列表
// const tabList = inject('tabList') as any
// console.log('tabList', tabList);

export default /*#__PURE__*/_defineComponent({
  __name: 'minimalism',
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const tabList = ref([]);

    const tabClick = (item, index) => {
      currentTabSelectIndex.value = index;
      currentTabData.value = item;
      getCategory();
    };

    const dataConfig = reactive({
      data: [],
      loading: false,
      listLoading: false
    });
    const currentTabData = ref(null);
    const currentTabSelectIndex = ref(0);

    const getData = async () => {
      dataConfig.loading = true;

      try {
        const {
          id
        } = currentVodPlusItem.value;
        const res = await getVodPlusIndexApi({
          parent: id
        });
        console.log(res);

        if (res.status == 200) {
          console.log('minima');
          tabList.value = res.data;
          currentTabData.value = tabList.value[0];
          getCategory();
        }
      } catch (error) {}

      dataConfig.loading = false;
    };

    const getCategory = async () => {
      dataConfig.listLoading = true;
      dataConfig.data = [];

      try {
        const res = await axiosInstanceAll({
          methods: 'get',
          url: '/vodPlus' + currentTabData.value.subCategoryUrl.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken')
          },
          noRepetition: true
        });

        if (res.status == 200) {
          dataConfig.data = res.data;
          dataConfig.listLoading = false;
        } else {
          dataConfig.listLoading = false;
        }
      } catch (error) {
        console.log(error);

        if (error.message !== 'canceled') {
          dataConfig.listLoading = false;
        }
      }
    };

    const onCardClick = item => {
      emit('onCardClick', item);
    };

    onMounted(() => {
      getData();
    });
    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentVodPlusItem = inject('currentVodPlusItem');
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "minimalism",
        "element-loading-background": _unref(currentUiStyleOptions).bgColor
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("span", {
          class: _normalizeClass([index == currentTabSelectIndex.value ? 'is-active' : '', "tabs pointer"]),
          onClick: $event => tabClick(item, index)
        }, _toDisplayString(item.name), 11, _hoisted_3)]);
      }), 128))])]), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "right-warp",
        "element-loading-background": _unref(currentUiStyleOptions).bgColor
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataConfig.data, (item, index) => {
        return _openBlock(), _createBlock(OtherStyleCardItem, {
          showImg: _unref(currentUiStyleOptions).showImg,
          onClick: $event => onCardClick(item),
          key: index,
          infoItem: item,
          poster: item.logo,
          "program-name": item.name,
          rating: item.rating
        }, null, 8, ["showImg", "onClick", "infoItem", "poster", "program-name", "rating"]);
      }), 128)), !dataConfig.data.length && !dataConfig.listLoading ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        style: {
          "width": "100%",
          "height": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)], 8, _hoisted_4)), [[_directive_loading, dataConfig.listLoading]])], 8, _hoisted_1)), [[_directive_loading, dataConfig.loading]]);
    };
  }

});